import React from "react";

const Footer = () => {
  return (
    <footer className="bg-white border-t shadow-sm p-4 w-full flex justify-center items-center">
      <p className="text-center text-gray-600 text-sm">
        © {new Date().getFullYear()} Developed by{" "}
        <span className="text-blue-600 font-semibold">Soft Coders</span>. All
        Rights Reserved.
      </p>
    </footer>
  );
};

export default Footer;
